// function applyViewMode() {
//   const grid = document.querySelector('.product-grid');
//   const savedView = localStorage.getItem('view_mode') || 'grid';
//   if (grid) {
//     grid.classList.remove('grid_col', 'list_col');
//     grid.classList.add(savedView === 'list' ? 'list_col' : 'grid_col');
//   }
// }
// function handleViewToggle(target) {
//   if (target.closest('.grid_icon')) {
//     localStorage.setItem('view_mode', 'grid');
//     applyViewMode();
//   }
//   if (target.closest('.list_icon')) {
//     localStorage.setItem('view_mode', 'list');
//     applyViewMode();
//   }
// }
// document.addEventListener('DOMContentLoaded', function () {
//   applyViewMode();
//   document.body.addEventListener('click', function (e) {
//     handleViewToggle(e.target);
//   });
//   const observer = new MutationObserver(() => {
//     applyViewMode();
//   });
//   observer.observe(document.body, {
//     childList: true,
//     subtree: true
//   });
// });


function applyViewMode() {
  const grid = document.querySelector('.product-grid');
  const savedView = localStorage.getItem('view_mode') || 'grid';

  if (grid) {
    grid.classList.remove('grid_col', 'list_col');
    grid.classList.add(savedView === 'list' ? 'list_col' : 'grid_col');
  }

  // ✅ Add/remove active class
  const gridIcon = document.querySelector('.grid_icon');
  const listIcon = document.querySelector('.list_icon');
  if (gridIcon && listIcon) {
    gridIcon.classList.remove('active');
    listIcon.classList.remove('active');
    if (savedView === 'list') {
      listIcon.classList.add('active');
    } else {
      gridIcon.classList.add('active');
    }
  }
}

function handleViewToggle(target) {
  if (target.closest('.grid_icon')) {
    localStorage.setItem('view_mode', 'grid');
    applyViewMode();
  }
  if (target.closest('.list_icon')) {
    localStorage.setItem('view_mode', 'list');
    applyViewMode();
  }
}

document.addEventListener('DOMContentLoaded', function () {
  applyViewMode();
  document.body.addEventListener('click', function (e) {
    handleViewToggle(e.target);
  });
  const observer = new MutationObserver(() => {
    applyViewMode();
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
